import { render, staticRenderFns } from "./ArchieLoader.vue?vue&type=template&id=962cfaca&"
import script from "./ArchieLoader.vue?vue&type=script&lang=js&"
export * from "./ArchieLoader.vue?vue&type=script&lang=js&"
import style0 from "./ArchieLoader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports